'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FreightTime = function () {
  function FreightTime($http, $q) {
    'ngInject';

    _classCallCheck(this, FreightTime);

    this._$http = $http;
    this._$q = $q;
  }

  _createClass(FreightTime, [{
    key: 'query',
    value: function query() {
      var request = {
        url: '/api/freightTime',
        method: 'GET'
      };

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: 'save',
    value: function save(times) {
      var request = {};
      request.url = '/api/freightTime';
      request.method = 'POST';

      request.data = times;

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }]);

  return FreightTime;
}();

exports.default = FreightTime;


// WEBPACK FOOTER //
// ./client/components/services/freightTime.service.js